
import { Sidebar } from "@/components/layout/SidebarNav";
import { Outlet } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Toaster } from "sonner";
import { BrandingProvider } from "@/components/BrandingProvider";

export function AppLayout() {
  return (
    <BrandingProvider>
      <SidebarProvider>
        <div className="flex h-screen w-full overflow-hidden">
          {/* Barra lateral fixa */}
          <div className="h-full border-r border-border bg-background transition-all duration-300 flex-shrink-0 overflow-hidden">
            <Sidebar />
          </div>
          
          {/* Área de conteúdo principal com scroll */}
          <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
            <main className="flex-1 overflow-y-auto p-4 md:p-8">
              <Outlet />
            </main>
          </div>
          
          {/* Toast notifications for real-time feedback */}
          <Toaster richColors />
        </div>
      </SidebarProvider>
    </BrandingProvider>
  );
}

export default AppLayout;
